// extracted by mini-css-extract-plugin
export default {"globalbanner":"style_globalbanner__EwGKj"};